export const roleOptions = [
  { label: 'Manager', value: 'manager' },
  { label: 'Individual Contributor', value: 'full_member' },
];

export const usingWPOptions = [
  'Keep my 1:1’s in one place',
  'Improve my relationship with my team',
  'Have better group meetings',
];

export const usingWPOptionsForInvited = [
  'Stay in sync with my manager',
  'Have better group meetings',
  'I don’t know why I was invited to PI Perform',
];

export const usingWPPreviewOptions = {
  'Keep my 1:1’s in one place': 'Staying organized',
  'Improve my relationship with my team': 'Being a good leader',
  'Have better group meetings': 'Being a team player',
};

export const discussionTopicOptions = [
  'What are you blocked on this week?',
  'What are your top priorities this week?',
  'How are you feeling today?',
  'What metrics are we improving?',
];

export const invitationTopicOptions = [
  'I am blocked on',
  'My priorities this week are',
  'I am feeling worried about',
  'What metrics are we improving?',
];

export const exampleKudos = {
  gifUrl: {
    fixed_width: { url: 'https://media.giphy.com/media/1QffP8E6nk4gKYZO5S/giphy.gif' },
  },
  likeThatText: 'Thanks for doing that thing! Can’t wait to see you in person again one day.',
  likeThatVideo: null,
};

export const blankKudos = {
  gifUrl: null,
  likeThatText: null,
  likeThatVideo: null,
};

export const recurrenceIntervalOptions = [
  { value: 'week', label: 'weeks' },
  { value: 'month', label: 'months' },
];

export const defaultWeekCountInDays = 7;
export const defaultMonthCountInDays = 28;
export const maxTimeWithoutPromptInDays = 30;

export const AVATAR_REQUIRED_MESSAGE = 'Field Avatar is required';
